import { decodeBase58 } from '@spazious/dollhouse-utils';

/**
 * Decode a selector buffer to string
 * @param input
 */
export const decode = (input: string): Buffer => decodeBase58(input);
